module.exports = __webpack_public_path__ + "static/media/trip.d8b2fed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/trip.jpg
// module id = 466
// module chunks = 0